<template>
  <section
    class="pt-60 pb-20 overflow-hidden"
    data-aos="fade-up"
    :data-aos-delay="200"
  >
    <div class="row y-gap-20 justify-between items-center">
      <div class="col-lg-6">
        <div class="sectionTitle">
          <h2 class="sectionTitle__title">Recommended Articles</h2>
          <p class="sectionTitle__text">
            Based on your recent interest in data science, we’ve picked these
            for you
          </p>
        </div>
      </div>

      <div class="col-auto mb-3">
        <a href="instructors-list-1.html" class="button -icon">
          {{ $t("view_all") }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6" v-for="i in 3" :key="i">
        <article-card />
      </div>
    </div>
  </section>
</template>

<script>
import AOS from "aos";
import ArticleCard from "../common/ArticleCard.vue";
export default {
  components: {
    ArticleCard,
  },
  data() {
    return {};
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
